





















import { Vue, Prop, Component } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
@Component({
  name: 'MainTitle',
  components: { Chart }
})
export default class extends Vue {
  @Prop({ default: '#00B66C' }) private color!: string

  @Prop({}) private levelList!: any

  @Prop({}) private colorList!: any
  @Prop({}) private chartData!: any
  @Prop({}) private chartNames!: any

  private chartId: string = ''
  created() {
    this.chartId = new Date().getTime() + '_' + parseInt(Math.random() * 10000000 + '')
    this.option.xAxis.data = this.chartNames
    this.chartData.map((v: any) => {
      this.option.series.push({
        itemStyle: {
          borderColor: '#FFFFFF'
        },
        stack: '总量',
        barWidth: 22,
        data: v,
        type: 'bar',
        z: 10
      })
    })
    this.option.series[0].markLine = {
      symbol: 'none',
      lineStyle: {
        type: 'dotted',
        color: '#979797'
      },
      data: []
    }
    this.chartNames.map((v, index) => {
      if (index !== this.chartNames.length - 1) {
        this.chartData.map((q, qIndex) => {
          let num1 = q[index]
          let num2 = q[index + 1]
          this.chartData.map((z, zIndex) => {
            if (zIndex < qIndex) {
              num1 += z[index]
              num2 += z[index + 1]
            }
          })
          this.option.series[0].markLine.data.push([{
            coord: [v, num1]
          },
          {
            coord: [this.chartNames[index + 1], num2]
          }
          ])
        })
      }
    })
    // console.info(this.option)
  }
  private option: any = {
    color: this.colorList,
    grid: {
      left: 50,
      right: 20,
      top: 30,
      bottom: 50
    },
    xAxis: {
      type: 'category',
      data: [],
      splitLine: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      offset: 10
    },
    yAxis: {
      type: 'value',
      splitLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisLine: {
        show: false
      },
      axisLabel: {
        color: '#999999'
      }
    },
    animation: false,
    series: []
    // series: [{
    //   stack: '总量',
    //   barWidth: 22,
    //   data: [10, 10, 10],
    //   type: 'bar',
    //   itemStyle: {
    //     borderColor: '#FFFFFF'
    //   },
    //   markLine: {
    //     symbol: 'none',
    //     lineStyle: {
    //       type: 'dotted',
    //       color: '#979797'
    //     },
    //     data: [
    //       [{
    //           coord: ['小班', 10]
    //         },
    //         {
    //           coord: ['中班', 10]
    //         }
    //       ],
    //       [{
    //           coord: ['中班', 10]
    //         },
    //         {
    //           coord: ['大班', 10]
    //         }
    //       ],

    //       [{
    //           coord: ['小班', 30]
    //         },
    //         {
    //           coord: ['中班', 30]
    //         }
    //       ],
    //       [{
    //           coord: ['中班', 30]
    //         },
    //         {
    //           coord: ['大班', 30]
    //         }
    //       ]
    //     ]
    //   },
    //   z: 10
    // }, {
    //   itemStyle: {
    //     borderColor: '#FFFFFF'
    //   },
    //   stack: '总量',
    //   barWidth: 22,
    //   data: [20, 20, 20],
    //   type: 'bar',
    //   z: 10
    // }, {
    //   itemStyle: {
    //     borderColor: '#FFFFFF'
    //   },
    //   stack: '总量',
    //   barWidth: 22,
    //   data: [20, 20, 20],
    //   type: 'bar',
    // }, {
    //   itemStyle: {
    //     borderColor: '#FFFFFF'
    //   },
    //   stack: '总量',
    //   barWidth: 22,
    //   data: [20, 20, 20],
    //   type: 'bar',
    //   z: 10
    // }, {
    //   itemStyle: {
    //     borderColor: '#FFFFFF'
    //   },
    //   stack: '总量',
    //   barWidth: 22,
    //   data: [20, 20, 20],
    //   type: 'bar',
    //   z: 10
    // }]
  }
}
